import axios from 'axios';
import * as insuranceActions from '../../actions/insurance-comp-info-actions/insurance-comp-info-actions';
import { getToken } from '../aws/token';
import { history } from '../../history';
const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';
let REQUEST_TYPE = 'application/json';
let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';
export function getInsuranceCompanyByDetail(authToken) {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      Authorization: `Bearer ` + token1,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch(insuranceActions.setAgentRemoveInfoError());
    dispatch(insuranceActions.setInsurancePending(true));
    axios
      .get(
        `${API_ENDPOINT}/v1/surety-bond/customer/info/insurance/companies`,
        config,
      )
      .then(response => {
        dispatch(insuranceActions.setInsuranceSuccess(false, response.data));
      })
      .catch(error => {
        if (error.response.status >= 500) {
          dispatch(
            insuranceActions.setAgentInfoError(
              false,
              ' ERR:NCP-INSU-SERV-DOWN',
            ),
          );
          dispatch(
            insuranceActions.setErrorPage(false, ' ERR:NCP-INSU-SERV-DOWN'),
          );
          history.push('/error');
        } else if (error.response.status === 409) {
          dispatch(insuranceActions.setErrorPage(false, 'ERR:NCP-DB-DOWN'));
          history.push('/error');
        } else {
          dispatch(
            insuranceActions.setInsuranceError(
              false,
              error.response.data.message,
            ),
          );
        }
      });
  };
}
